import React, { FC } from 'react';
import { Loan } from '../../../interfaces';
import { BorrowerInfo } from './BorrowerInfo';

type Props = {
  loan: Loan;
};

export const PaydayLoanDetail: FC<Props> = ({ loan }) => {
  return (
    <>
      <BorrowerInfo borrower={loan.borrower} />
    </>
  );
};
